import { View } from "binder"
import { ListEditorViewModel } from "./listEditor-viewModel"

export class ListEditorView extends View<ListEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-9816110D-7FF2-47E1-8D6E-02B2A5FF8542"
    }
    loadHtml(): string {
        let element = require('./listEditor.html').default;
        let style = require('./listEditor.less');
        return element;
    }
    constructor() {
       super();
    }
}
